"use client";

import React, { useEffect, useState } from 'react'
import { WrapMain } from '../../../shared/modules/wrap_main'
import '../../../styles/globalstyles.scss';
import './styles.scss';
import { title } from 'process';
import { useDispatch, useSelector } from 'react-redux';
import { mainSlice } from '../../../stateManagement/redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { RoutesWeb } from '../../../shared/interfaces/routes';
import { selectMainState } from "../../../stateManagement/redux";
import { Tooltip } from '@mui/material';

export interface ProjectsCardProps {
  id: string,
  title: string;
  icon: string;
  description: string;
  path: string;
  alert?: string;
  roles?: string[];
  disabled?: boolean;
}

export const uploadViews: ProjectsCardProps[] = [
  {
    id: 'uploadV1',
    title: 'Monitoreo Optimización',
    icon: '/assets/icons/leuter_digital.svg',
    description: 'Por este modulo se podrá cargar los archivos de monitoreo de optimización BCP y BM',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_monitoreo
  },
  {
    id: 'uploadV2',
    title: 'Monitoreo Optimización Oriente',
    icon: '/assets/images/bcp.jpg',
    description: 'Por este modulo se podrá cargar los archivos de monitoreo de optimización pozos BCP',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_monitoreoV2
  },
  {
    id: 'pocotras',
    title: 'Pocotras',
    icon: '/assets/icons/tds.svg',
    description: 'Por este modulo se podrá cargar los archivos en formato pocotras',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_well_files,
    roles: ['data']
  },
  {
    id: 'aico',
    title: 'Aico',
    icon: '/assets/icons/aicoTrend.svg',
    description: 'Por este modulo se podrá cargar los archivos en formato aico',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_well_files,
    roles: ['data']
  },
  {
    id: 'ays',
    title: 'Consolidados de Muestras',
    icon: '/assets/icons/labAyS.svg',
    description: 'Por este modulo se podrá cargar los archivos en formato aico',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_well_files,
    roles: ['data']
  },
  {
    id: 'wellTags',
    title: 'Actualización de Tags a Pozos',
    icon: '/assets/icons/wellTags.svg',
    description: 'Por este modulo se podrá cargar los archivos en formato aico',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_well_files,
    roles: ['data'],
    disabled: false,
  },
  {
    id: 'mesasTecnicas',
    title: 'Mesas Técnicas de Aplicaciones',
    icon: '/assets/icons/meet.svg',
    description: 'Por este modulo se podrá cargar los archivos en formato aico',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_well_files,
    roles: ['data'],
    disabled: false,
  },
  {
    id: 'backupMobile',
    title: 'Gestion de Respaldos Mobile',
    icon: '/assets/icons/backUpMobile.svg',
    description: 'Por este modulo se podrá gestionar los respaldos de la app movil',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_backup_mobile,
    roles: ['data'],
    disabled: false,
  }
]

const UploadCard = (props: ProjectsCardProps) => {

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const onClickMenu = (path: string, activeProject: string) => {
    dispatch(mainSlice.actions.setActiveProjectId(activeProject));
    localStorage.setItem('activeProjectId', activeProject);
    navigate(`${path}?id=${activeProject}`);
  }


  return (
    <Tooltip title={props.disabled ? 'No disponible' : props.title} arrow>
      <div className='card_container' onClick={!props.disabled ? () => onClickMenu(props.path, props.id) : () => { }}
        style={{ cursor: props.disabled ? 'not-allowed' : 'pointer', opacity: props.disabled ? 0.5 : 1 }}
      >
        <img src={props.icon} width={120} height={120} alt='' />
        <div className='card_container__title' > {props.title} </div>
        <div className='card_container__description'> {props.description} </div>
        {props.alert && (
          <div className='card_container__alertSection'>
            <img src="/assets/icons/info.svg" width={20} height={20} alt='' />
            {props.alert}
          </div>
        )}

      </div>
    </Tooltip>
  )
}

const Upload = () => {

  const { configModules, activeUser } = useSelector(selectMainState);

  const [listOfVisitedModules, setlistOfVisitedModules] = useState<string[]>([])

  useEffect(() => {
    if (Array.isArray(configModules?.enabledUploadModules)) {
      setlistOfVisitedModules(configModules?.enabledUploadModules)
    }
  }, [configModules, activeUser])


  return (
    <div className='upload_container'>
      <div className='upload_container_title_section'>
        <div className='upload_container_title_section__title'>Subir Archivos de actividades</div>
        <div className='upload_container_title_section__detail'>Seleccionar tipo de actividad realizada y subir archivo correspondiente</div>
      </div>
      <div className='upload_container_cards_section'>
        {uploadViews.map((card, i) => {

          if (!listOfVisitedModules.includes(card.id)) return null

          if (card.roles && card.roles?.length > 0) {
            let showCard = false;
            activeUser?.role?.forEach((role) => {
              if (card.roles?.includes(role)) {
                showCard = true;
              }
            });
            if (!showCard) return null;
          }

          return (
            <UploadCard key={i} icon={card.icon} title={card.title} description={card.description} alert={card.alert} path={card.path} id={card.id} disabled={card.disabled} />)
        })}
      </div>
    </div>
  )
}

const index = () => {
  return (
    <WrapMain>
      <Upload />
    </WrapMain>
  )
}

export default index